<template>
  <div class="comp-coop">
    <router-link :to="`${$subsitePrefix}/achievement/show/research/detail/${data.Id}`" :target="target">
      <div class="img">
        <img @error="imgError" :src="data.Illustration || '/static/img/yjy.jpg'" :alt="data.Name" />
      </div>
    </router-link>
    <h3 class="name">
      <router-link :to="`${$subsitePrefix}/achievement/show/research/detail/${data.Id}`" :target="target">{{ data.Name }}</router-link>
    </h3>
    <p class="desc">{{ data.Introduction }}</p>
  </div>
</template>

<script>
export default {
  name: "Research-card",
  props: {
    data: {
      type: Object
    },
    target: {
      type: String,
      default: "_self"
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-coop {
  width: 276px;
  // height: 334px;
  height: 190px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.08);
  border-radius: 8px;
  border: 1px solid rgba(238, 238, 238, 1);
  margin-left: 24px;
  box-sizing: border-box;
  margin-bottom: 24px;
  .name {
    margin: 0 32px 10px 32px;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    @include ellipsisc(2);
  }
  .desc {
    color: #999;
    line-height: 22px;
    margin: 16px 32px 10px 32px;
    @include ellipsisc(6);
    height: 110px;
  }
  .img {
    width: 212px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 32px auto;
  }
  &:nth-child(4n-3) {
    margin-left: 0;
  }
  &:hover {
    box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.16);
    border: 1px solid rgba(238, 238, 238, 1);
  }
}
</style>
